import React, { useEffect, useState } from 'react'
import 'animate.css/animate.min.css'
import styled from 'styled-components'
import { FitText } from '@gojiraf/responsive'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from '../Kit/Buttons'
import { useCheckout } from '../../hooks/useCheckout'
import PropTypes from 'prop-types'
import { selectQuickAdd, setQuickAdd } from '../../reducers/uiSlice'

const QuickAddButton = ({ featuredProduct, store }) => {
  const { t } = useTranslation()
  const [animationClass, setAnimationClass] = useState('')
  const {
    handleQuickAddClick,
    getItemsInCart,
    clickBuyCheckout,
    setClickBuyCheckout,
    handleOnBuyClicked,
  } = useCheckout(store)
  const itemsInCart = getItemsInCart()
  const showQuickAdd = useSelector(selectQuickAdd)
  const dispatch = useDispatch()

  useEffect(() => {
    const executeAnimation = async () => {
      setAnimationClass('animate__backInUp animate__speed-1s')
      setTimeout(() => {
        setAnimationClass('animate__heartBeat animate__infinite')
      }, 1000)
      await new Promise((resolve) => {
        setTimeout(() => {
          setAnimationClass('animate__backOutDown')
          resolve()
        }, 7500)
      })
      setTimeout(() => {
        dispatch(setQuickAdd(false))
      }, 1500)
    }
    if (showQuickAdd) executeAnimation()
  }, [showQuickAdd])

  useEffect(() => {
    if (clickBuyCheckout) {
      const total = getItemsInCart().reduce((acc, item) => acc + item.price * item.quantity, 0)
      handleOnBuyClicked({ total, selectedDeliveryMethod: 'unavailable' })
      setClickBuyCheckout(false)
    }
  }, [itemsInCart])

  const handleClick = () => {
    handleQuickAddClick(featuredProduct)
    setAnimationClass('animate__backOutDown')
    setTimeout(() => {
      dispatch(setQuickAdd(false))
    }, 1500)
  }

  const getCurrentText = () => {
    if (featuredProduct?.skus.length > 1) return t('products.viewProduct')
    return t('products.buy')
  }

  return (
    <>
      {showQuickAdd ? (
        <Container>
          <Button
            className={`animate__animated ${animationClass}`}
            variant="contained"
            color="primary"
            onClick={handleClick}
            style={{ maxWidth: '57%' }}
          >
            <FitText min={8}>{getCurrentText()}</FitText>
          </Button>
        </Container>
      ) : null}
    </>
  )
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 50%;
  /* El botón escalado ocupa hasta 57% x 1.75 ≈ 100% del ancho del card */
  scale: 1.75;
  transform-origin: center;
  z-index: 1;
`

QuickAddButton.propTypes = {
  featuredProduct: PropTypes.object,
  store: PropTypes.object,
}

export default QuickAddButton
